import React, { useState } from "react"
import styled from "styled-components"

import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation, Thumbs } from "swiper"

import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/thumbs"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const Container = styled.div`
  .main-swiper {
    margin-bottom: 5px;

    .swiper-wrapper {
      display: flex;
      align-items: center;

      .swiper-slide {
        height: 100%;

        img {
          border-radius: 10px;
          object-fit: cover;
          aspect-ratio: 16 / 9;
        }
      }
    }
    .swiper-button-next,
    .swiper-button-prev {
      display: none;
    }
  }

  .thumbnails {
    .gatsby-image-wrapper {
      border-radius: 5px;
      max-height: 30px;
      filter: saturate(0);
      opacity: 0.7;
      border: 2px solid transparent;

      :hover {
        cursor: pointer;
        filter: saturate(1);
      }
    }

    .swiper-slide-thumb-active .gatsby-image-wrapper {
      opacity: 1;
      filter: saturate(1);
      border: 2px solid ${({ theme }) => theme.palette.scienceBlue};
    }
  }
`

type Props = {
  images: any[]
}

const ImageSwiper: React.FC<Props> = ({ images }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null)

  return (
    <Container>
      <Swiper
        className="main-swiper"
        spaceBetween={30}
        slidesPerView={1}
        modules={[Navigation, Thumbs]}
        thumbs={{ swiper: thumbsSwiper }}
        navigation={true}
        loop={true}
      >
        {images.map((image, index) => (
          <SwiperSlide key={"swiper-image-slide" + index}>
            <GatsbyImage key={"swiper-image-" + index} alt="image" image={image} sizes="10px" />
          </SwiperSlide>
        ))}
      </Swiper>
      {images.length > 1 ? (
        <Swiper
          className="thumbnails"
          spaceBetween={10}
          slidesPerView={images.length - 1.7}
          modules={[Thumbs]}
          watchSlidesProgress
          onSwiper={setThumbsSwiper}
          breakpoints={{
            460: {
              slidesPerView: images.length - 0.7,
            },
            1024: {
              slidesPerView: images.length,
            },
          }}
        >
          {images.map((image, index) => (
            <SwiperSlide key={"thumbnail-image-slide" + index}>
              <GatsbyImage key={"thumbnail-image-" + index} alt="image" image={image} />
            </SwiperSlide>
          ))}
        </Swiper>
      ) : null}
    </Container>
  )
}

export default ImageSwiper
